<template>
  <div
    v-masonry
    fit-width="true"
    transition-duration="0s"
    item-selector=".card_box"
    gutter="10"
    class="short_video"
    v-if="newFlag"
  >
    <div
      v-masonry-tile
      v-for="(item, index) in list"
      :key="index"
      @click="goDetail(item)"
      class="card_box"
      :style="{ width: newWidth + 'px' }"
    >
      <div
        class="head_img"
        :style="{ height: item?.height, width: newWidth + 'px' }"
        v-if="item?.attachments[0] && item?.attachments[0].status === 3"
      >
        <img :src="filterImg(item?.attachments[0])" alt="''" />
        <div class="tag" v-if="item?.boardToppingStatus === 1">{{ $t('pc_community_top') }}</div>
        <div class="play_button">
          <i class="iconfont icon-icon_shequzhongxin_bofang" />
        </div>
      </div>
      <div class="head_bg" :style="{ height: item?.height, width: newWidth + 'px' }" v-else>
        <div class="Lottie_color">
          <LottieFlow />
        </div>
        <p class="announcing_text">{{ $t('under_release_h5') }}</p>
        <p class="announcing_text">{{ $t('video_refresh_h5') }}</p>
      </div>
      <div class="card_introduction">
        <p class="title">{{ item.title }}</p>
        <div class="with_title">
          <div class="playback_box name_width">
            <VanImage width="16px" height="16px" :src="item.avatarFileUrl" class="avatar" round />
            <span class="name">{{ item.createByName }}</span>
          </div>
          <div class="playback_box playback_width">
            <i class="iconfont icon-icon_shequzhongxin_bofang" />
            <span class="playback">{{ item.viewCount }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance, nextTick, ref, watch } from 'vue'
import { Image as VanImage, showToast } from 'vant'
import { useRouter } from 'vue-router'
import { Record } from '@/api/Models/CommunityBoardContentList'
import { screenWidth } from '@/utils'
import { useVideoStore } from '@/stores/video'
import { loading } from '@/utils/loading'
import { useComponentStore } from '@/stores/components'
import { storeToRefs } from 'pinia'
import LottieFlow from './LottieFlow.vue'
import { useI18n } from 'vue-i18n'
const router = useRouter()
const newWidth = (screenWidth - 42) / 2
const { t } = useI18n()
const defaultPhoto = require('@/assets/images/defalut_short_video.png')

const props = defineProps<{
  articleData: Record[]
  active?: number
}>()

const videoStore = useVideoStore()
const list = ref<Record[]>(props.articleData)

const newFlag = ref<boolean>(true)

const filterImg = computed(() => (item: { status?: number; coverUrl?: string }) => {
  if (item?.status === 3) {
    if (item?.coverUrl) {
      return item?.coverUrl
    } else {
      return defaultPhoto
    }
  } else {
    return defaultPhoto
  }
})

const goDetail = (item: Record) => {
  if (+item.attachments[0]?.status === 3) {
    // 转码成功
    videoStore.setFirstVideoData(item)
    const componentsStore = useComponentStore()
    const { includeComponents } = storeToRefs(componentsStore)
    if (!includeComponents.value.includes('communityDetail')) {
      componentsStore.setIncludeComponents([...includeComponents.value, 'communityDetail'])
    }
    router.push({
      path: '/rollVideo',
      query: {
        sortType: props.active,
        boardId: item.boardId,
        id: item.id
      }
    })
  } else {
    showToast(t('video_processing_h5'))
  }
}

const that = getCurrentInstance()?.appContext.config.globalProperties
watch(
  props,
  (newData) => {
    list.value = newData.articleData
    list.value.forEach((e: Record) => {
      if (e?.attachments && e?.attachments[0]) {
        const num = e?.attachments[0]?.expandInfo ? JSON.parse(e?.attachments[0]?.expandInfo) : 168
        if (e?.attachments[0]?.coverUrl) {
          if (num.videoWidth > num.videoHeight) {
            e.height = Math.floor((newWidth / 4) * 3) + 'px'
          } else {
            e.height = Math.floor((newWidth / 3) * 4) + 'px'
          }
        } else {
          e.height = Math.floor((newWidth / 3) * 4) + 'px'
        }
      }
    })
    that?.$redrawVueMasonry()
  },
  {
    immediate: true,
    deep: true
  }
)

const isFlag = () => {
  return (newFlag.value = true)
}

watch(
  () => props.active,
  () => {
    loading.show()
    newFlag.value = false
    nextTick(() => {
      setTimeout(isFlag, 1000)
    })
    setTimeout(() => {
      loading.hide()
    }, 1100)
  }
)

</script>

<style scoped lang="less">
@import url('@/styles/variables.less');
.short_video {
  width: 100%;
  .card_box_flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .card_box_column {
    display: flex;
    flex-direction: column;
  }
  .card_box {
    width: 174px;
    background: #ffffff;
    border-radius: 4px;
    margin-bottom: 10px;
    .head_bg {
      background: #f0f0f0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .announcing_text {
        color: #999999;
        font-size: 13px;
        padding: 0 10px;
        text-align: center;
      }
      .Lottie_color {
        opacity: 0.1;
      }
    }
    .head_img {
      position: relative;
      border-radius: 4px 4px 0 0;
      img {
        border-radius: 4px 4px 0 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .tag {
        position: absolute;
        top: 8px;
        left: 8px;
        padding: 0 4px;
        height: 19px;
        font-size: 11px;
        font-weight: 500;
        border-radius: 2px;
        background: #f39b00;
        line-height: 19px;
        text-align: center;
        color: #ffffff;
      }
      .play_button {
        position: absolute;
        right: 16px;
        bottom: 16px;
        width: 22px;
        line-height: 22px;
        opacity: 0.5;
        background: #000000;
        border-radius: 50%;
        display: flex;
        align-items: center;
        padding: 0 6px;
        .iconfont {
          color: #ffffff;
          font-size: 8px;
        }
      }
    }
  }
  .card_introduction {
    width: 100%;
    padding: 12px 8px;
    .title {
      font-size: 14px;
      font-weight: 500;
      min-height: 20px;
      margin-bottom: 8px;
      .text_multiple_etc(2);
    }
    .with_title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .name {
        display: inline-block;
        color: #61666d;
        font-size: 12px;
        width: 83%;
        .text_etc;
      }
      .playback_box {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .iconfont {
          font-size: 10px;
          transform: scale(0.8);
          margin-right: 2px;
          color: #999999;
        }
      }
      .name_width {
        width: 80%;
        justify-content: flex-start;
      }
      .playback_width {
        flex: 1;
        justify-content: flex-end;
      }
      .avatar {
        margin-right: 4px;
        border-radius: 50%;
      }
      .playback {
        font-size: 10px;
        color: #999999;
      }
    }
  }
}
</style>
